import React, { useRef, useEffect } from 'react';

const MobileHomeReview = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const handlePlayPause = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      });
    };

    const observer = new IntersectionObserver(handlePlayPause, {
      threshold: 0.5, // Adjust this value as needed
    });

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <div className="bg-dark border rounded w-100 h-100">
      <video 
        ref={videoRef} 
        src="https://skillsuprise.com/data/videos/home-review-main.mp4" 
        poster="https://skillsuprise.com/data/videos/home-review-main.png" 
        className="w-100 h-100"
       // Optional: mutes the video so it can autoplay without user interaction
      ></video>
    </div>
  );
}

export default MobileHomeReview;
